module.exports = __webpack_public_path__ + "static/img/icon_north.48840f67.svg";